export default __webpack_public_path__ + "media/comingSoon.c2b56bb5.png";